import { CodeRefDisplayMode } from '@/shared/helpers/api/types/entities.ts';

type CodeDisplayFields = {
    name: string;
    identity: string;
    description: string | null;
};
export function getReferenceCodeLabel(referenceDisplayMode: CodeRefDisplayMode, refCode: CodeDisplayFields): string {
    switch (referenceDisplayMode) {
        case 0: return refCode.identity;
        case 1: return refCode.name;
        case 2: return refCode.description ?? '{No description}';
        case 3: return `${refCode.name} - ${refCode.description ?? '{No description}'}`;
        default:
            return refCode.identity;
    }
}
